<template>
	<div class="container">
		<!--内容-->
		<div class="main_box">
			<!--banner-->
			<div class="banner_box">
				<div class="left">
					<div
						class="tit"
						data-aos="fade-right"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
						style="padding-bottom: 18px;"
					>
						A 班长真知 @21
					</div>
					<div
						class="txt"
						data-aos="fade-right"
						data-aos-duration="400"
						data-aos-delay="400"
						data-aos-offset="0"
						data-aos-once="true"
						style="padding-bottom: 8px;"
					>库尔·企业文化</div>
					<div
						class="txt"
						data-aos="fade-right"
						data-aos-duration="400"
						data-aos-delay="700"
						data-aos-offset="0"
						data-aos-once="true"
					>
						@21&nbsp;意指
					</div>
					<div
						class="txt"
						data-aos="fade-right"
						data-aos-duration="400"
						data-aos-delay="1000"
						data-aos-offset="0"
						data-aos-once="true"
					>甭管三七二十一&nbsp;撸起袖子加油干</div>
				</div>
				<div class="right animate__animated animate__fadeIn">
					<img src="../../../assets/img_public/about/qywh/banner_img.png" />
				</div>
			</div>
			<!--banner-->
			<!--块1-->
			<div class="main_box_1">
				<!--关联网站-->
				<div class="link_box" data-aos="fade-up" data-aos-duration="400" data-aos-once="true">
					<!-- <div class="tit">关联网站</div> -->
					<div v-for="(value, index) in linkData" class="link_main">
						<div v-for="(value2, index2) in value.data" :class="value2.class">
							<a :href="value2.href">
								<img :src="value2.imgUrl" />
							</a>
						</div>
					</div>
				</div>
				<!--关联网站-->
				<!--区域1-->
				<div class="block_1" data-aos="fade-up" data-aos-duration="400" data-aos-once="true">
					<div class="img_box">
						<img src="../../../assets/img_public/about/qywh/block_bg_1.png" />
					</div>
					<div class="tit">大自然科学原理</div>
					<div class="txt">已经证实&nbsp;&&nbsp;当前无法验明真伪的存在</div>
				</div>
				<!--区域1-->
				<!--区域2-->
				<div class="block_2" data-aos="fade-up" data-aos-duration="400" data-aos-once="true">
					<div class="img_box">
						<img src="../../../assets/img_public/about/qywh/block_bg_2.png" />
					</div>
					<div class="tit">成长法则</div>
					<div class="txt">1.&nbsp;加强学习看能力</div>
					<div class="txt">2.&nbsp;持续落实执行度</div>
					<div class="txt">3.&nbsp;认识欠缺常纠正</div>
					<div class="txt">4.&nbsp;爱岗敬业有担当</div>
					<div class="txt">5.&nbsp;构建利益共同体</div>
				</div>
				<!--区域2-->
			</div>
			<!--块1-->
			<!--块2-->
			<div class="main_box_2">
				<!--区域1-->
				<div class="block_1">
					<div class="tit" data-aos="fade-up" data-aos-duration="400" data-aos-once="true">库尔精神</div>
					<div class="main_box">
						<div
							class="main_box_el"
							data-aos="zoom-in"
							data-aos-duration="400"
							data-aos-delay="400"
							data-aos-offset="0"
							data-aos-once="true"
						>
							<div class="title">取势</div>
							<div class="txt">认清大势</div>
							<div class="txt">顺应权利</div>
						</div>
						<div
							class="main_box_el"
							data-aos="zoom-in"
							data-aos-duration="400"
							data-aos-delay="800"
							data-aos-offset="0"
							data-aos-once="true"
						>
							<div class="title">明道</div>
							<div class="txt">了解本质</div>
							<div class="txt">懂得价值</div>
						</div>
						<div
							class="main_box_el"
							data-aos="zoom-in"
							data-aos-duration="400"
							data-aos-delay="1200"
							data-aos-offset="0"
							data-aos-once="true"
						>
							<div class="title">厚德</div>
							<div class="txt">重公轻私</div>
							<div class="txt">知恩图报</div>
						</div>
						<div
							class="main_box_el"
							data-aos="zoom-in"
							data-aos-duration="400"
							data-aos-delay="1600"
							data-aos-offset="0"
							data-aos-once="true"
						>
							<div class="title">优术</div>
							<div class="txt">对表改进</div>
							<div class="txt">清单革命</div>
						</div>
						<div
							class="main_box_el"
							data-aos="zoom-in"
							data-aos-duration="400"
							data-aos-delay="2000"
							data-aos-offset="0"
							data-aos-once="true"
						>
							<div class="title">尚果</div>
							<div class="txt">明确目标</div>
							<div class="txt">关键成果</div>
						</div>
						<div
							class="main_box_el"
							data-aos="zoom-in"
							data-aos-duration="400"
							data-aos-delay="2400"
							data-aos-offset="0"
							data-aos-once="true"
						>
							<div class="title">立法</div>
							<div class="txt">制定规章</div>
							<div class="txt">推广典范</div>
						</div>
					</div>
				</div>
				<!--区域1-->
				<!--区域2-->
				<div class="block_2" data-aos="fade-up" data-aos-duration="400" data-aos-once="true">
					<div class="img_box">
						<img src="../../../assets/img_public/about/qywh/block_bg_3.webp" />
					</div>
					<div class="tit">工作要件&nbsp;@21</div>
					<div class="tit_spec">只要工作&nbsp;就<span style="color: #DC000C;font-size: 18px;">&nbsp;🉐&nbsp;</span>️思考</div>
					<div class="txt">做什么，由谁做；</div>
					<div class="txt">何时，何地，如何做；</div>
					<div class="txt">使用什么&nbsp;文件设备物料；</div>
					<div class="txt">如何&nbsp;监视测量&nbsp;这些活动；</div>
					<div class="txt">相关方&nbsp;要求的记录证明。</div>
				</div>
				<!--区域2-->
				<!--区域1-->
				<div class="block_3" data-aos="fade-up" data-aos-duration="400" data-aos-once="true">
					<div class="img_box">
						<img src="../../../assets/img_public/about/qywh/block_bg_4.png" />
					</div>
					<div class="tit">两学一做</div>
					<div class="txt">学文化规章</div>
					<div class="txt">学专业技能</div>
					<div class="txt">做合格同事</div>
				</div>
				<!--区域1-->
			</div>
			<!--块2-->
			<!--块3-->
			<div class="main_box_3">
				<!--区域1-->
				<div class="block_1" data-aos="fade-up" data-aos-duration="400" data-aos-once="true">
					<div class="main_box">
						<div class="main_box_el">
							<div class="tit">办事原则</div>
							<div class="diver"></div>
							<div class="txt">依照规矩</div>
							<div class="txt">按部就班</div>
							<div class="txt">注重细节</div>
							<div class="txt">再谈创新</div>
						</div>
						<div class="main_box_el line_spec">
							<div class="tit">议事原则</div>
							<div class="diver"></div>
							<div class="txt">民主商议（三人行）</div>
							<div class="txt" style="padding-top: 11px;">权威管理（首席制）</div>
							<div class="txt" style="padding-top: 11px;">重大请示（总裁办）</div>
						</div>
					</div>
					<div class="main_box">
						<div class="main_box_el">
							<div class="tit">生产准则</div>
							<div class="diver"></div>
							<div class="txt">操作规范</div>
							<div class="txt">质量达标</div>
							<div class="txt">速度相当</div>
							<div class="txt">遵纪守时</div>
						</div>
						<div class="main_box_el line_spec">
							<div class="tit">中台四对</div>
							<div class="diver"></div>
							<div class="txt">对上敬</div>
							<div class="txt" style="padding-top: 0px;">对下慈</div>
							<div class="txt" style="padding-top: 0px;">对人和</div>
							<div class="txt" style="padding-top: 0px;">对事真</div>
						</div>
					</div>
				</div>
				<!--区域1-->
			</div>
			<!--块3-->
			<!--块4-->
			<div class="main_box_4">
				<!--区域1-->
				<div class="block_1" data-aos="fade-up" data-aos-duration="400" data-aos-once="true">
					<div class="img_box">
						<img src="../../../assets/img_public/about/qywh/block_bg_5.webp" />
					</div>
					<div class="tit">经营方针</div>
					<div class="txt">
						<span><img src="../../../assets/img_public/about/qywh/icon_1.png" /></span>完美品质&ensp;&ensp;&ensp;<span><img src="../../../assets/img_public/about/qywh/icon_2.png" /></span>真诚服务
					</div>
					<div class="txt">
						<span><img src="../../../assets/img_public/about/qywh/icon_3.png" /></span>规范管理&ensp;&ensp;&ensp;<span><img src="../../../assets/img_public/about/qywh/icon_4.png" /></span>开拓创新
					</div>
				</div>
				<!--区域1-->
				<!--区域2-->
				<div class="block_2">
					<div class="main_box" data-aos="zoom-in-up" data-aos-duration="400" data-aos-once="true">
						<div class="main_box_el">
							<div class="tit">CU 信念</div>
							<div class="diver"></div>
							<div class="txt">奉献创造价值</div>
						</div>
						<div class="main_box_el">
							<div class="tit">CU 宗旨</div>
							<div class="diver"></div>
							<div class="txt">安全有效&nbsp;&nbsp;使命必达</div>
						</div>
						<div class="main_box_el">
							<div class="tit">CU 口号</div>
							<div class="diver"></div>
							<div class="txt">想&nbsp;壮志凌云&nbsp;&nbsp;干&nbsp;脚踏实地</div>
						</div>
					</div>
				</div>
				<!--区域2-->
				<!--区域3-->
				<div class="block_3" data-aos="fade-up" data-aos-duration="400" data-aos-once="true">
					<div class="img_box">
						<img src="../../../assets/img_public/about/qywh/block_bg_6.png" />
					</div>
					<div class="txt_box">
						<div class="tit">CU 愿景</div>
						<div class="txt">从有机到安息&nbsp;&nbsp;全供应链服务&nbsp;&nbsp;@21亿人</div>
					</div>
					<div class="txt_box">
						<div class="tit">CU 人才观</div>
						<div class="txt">我们是一家人&nbsp;&nbsp;包容&取代</div>
						<div class="txt">欢迎A咖&nbsp;&nbsp;|&nbsp;&nbsp;断舍离B类</div>
					</div>
				</div>
				<!--区域3-->
			</div>
			<!--块4-->
			<!--块5-->
			<div class="main_box_5">
				<!--区域1-->
				<div class="block_1" data-aos="fade-up" data-aos-duration="400" data-aos-once="true">
					<div class="tit">CU 常态化</div>
					<div class="txt">真传帮带&nbsp;常态化</div>
					<div class="txt">红包激励&nbsp;常态化</div>
					<div class="txt">寻蟑找蝇&nbsp;常态化</div>
					<div class="tips_box">
						<div class="tips_el">蟑蝇之类：</div>
						<div class="tips_el">“ 蟑 ” 泛指 存在盗用物资、吃里扒外、讹诈钱财等行为</div>
						<div class="tips_el">“ 蝇 ” 泛指 具有消极怠工、散布反派言论等负能量</div>
					</div>
				</div>
				<!--区域1-->
			</div>
			<!--块5-->
			<!--块6-->
			<div class="main_box_6">
				<!--区域1-->
				<div class="block_1" data-aos="fade-up" data-aos-duration="400" data-aos-once="true">
					<div class="img_box">
						<img src="../../../assets/img_public/about/qywh/block_bg_7.png" />
					</div>
					<div class="txt_box">
						<div class="tit">CU 不二胡</div>
						<div class="tit_spec">&ensp;&ensp;胡干</div>
						<div class="txt">&ensp;1.1&nbsp;有标准、不按标准干，</div>
						<div class="txt">&ensp;1.2&nbsp;没有标准的、瞎干，</div>
						<div class="txt">&ensp;1.3&nbsp;明知道标准有问题、而不提出继续干；</div>
						<div class="tit_spec">&ensp;&ensp;胡说</div>
						<div class="txt">&ensp;2.1&nbsp;未经过调查研究、就想当然的那样，</div>
						<div class="txt">&ensp;2.2&nbsp;未经过尝试、就感觉一定可行，</div>
						<div class="txt">&ensp;2.3&nbsp;仅尝试一次或简单证明、就认定相关事项总是这样。</div>
					</div>
				</div>
				<!--区域1-->
				<!--区域2-->
				<div class="block_2" data-aos="fade-up" data-aos-duration="400" data-aos-once="true">
					<div class="tit">当前任务</div>
					<div class="txt">&ensp;&ensp;为全球提供 实惠 易用 精准 的诊断产品</div>
					<div class="txt">&ensp;&ensp;一起改变全球诊断</div>
				</div>
				<!--区域2-->
				<!--区域3-->
				<div class="block_3" data-aos="fade-up" data-aos-duration="400" data-aos-once="true">
					<!-- <div class="img_box">
						<img src="../../../assets/img_public/about/qywh/block_bg_8.png" @click="bfVideo" />
					</div> -->
					<div class="txt_box">
						<!-- <span class="icon">.</span> -->
						<span class="tit">人生</span>
						<span class="txt">忠孝难两全&nbsp;选好黄金点</span>
					</div>
					<div class="txt_box">
						<!-- <span class="icon">.</span> -->
						<span class="tit">人性</span>
						<span class="txt">人们首先关心自己</span>
					</div>
				</div>
				<!--区域3-->
			</div>
			<!--块6-->
			<!--块7-->
			<div class="main_box_7">
				<!--区域1-->
				<div class="block_1" data-aos="fade-up" data-aos-duration="400" data-aos-once="true">
					<div class="tit">这个世界</div>
					<div class="txt">一切都是动态的&nbsp;与时俱进</div>
					<div class="img_box">
						<!-- <img src="../../../assets/img_public/about/qywh/icon_earth.png" /> -->
						<!-- <video ref="videoDom" muted autoplay loop
					      :controls="false"
						  x5-video-player-type="h5"
						  webkit-playsinline="true"
						  x-webkit-airplay="true"
						  playsinline="true"
						  x5-video-player-fullscreen="true"
						  muted>
							<source src="https://culture.baoyitong.com.cn/world.mp4" type="video/mp4">
						</video> -->
						<video
							webkit-playsinline="true"
							x-webkit-airplay="true" 
							playsinline="true" 
							x5-video-player-type="h5"
							x5-video-player-fullscreen="true" 
							width="100%" 
							height="100%"
							ref="example_video" 
							class="video-js" 
							preload='auto'
							autoplay='true'
							loop
							muted
						>
							<source src="https://culture.baoyitong.com.cn/world.mp4?t=1" type="video/mp4">
						</video>
					</div><!--https://culture.baoyitong.com.cn/world.mp4-->
				</div>
				<!--区域1-->
			</div>
			<!--块7-->
		</div>
		<!--内容-->
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import navbar from '@/component/h5/nav.vue'  //导航组件
import footerBox from '@/component/h5/footer.vue'  //版权组件
export default {
	components:{
		navbar,
		footerBox,
	},
	data() {
		return {
			isLoading: true,  //界面loading
			linkData: [
				{data: [
					{imgUrl: require('@/assets/img_public/about/qywh/link_7.png'), href: 'https://cordx.com/', class: 'link_img_7'},
					{imgUrl: require('@/assets/img_public/about/qywh/link_5.png'), href: 'https://bonoplastics.com', class: 'link_img_3'},
					{imgUrl: require('@/assets/img_public/about/qywh/link_3.png'), href: 'https://www.abiores.com/', class: 'link_img_2'},
				]},
				{data: [
					{imgUrl: require('@/assets/img_public/about/qywh/link_2.png'), href: 'https://jtests.com', class: 'link_img_4'},
					{imgUrl: require('@/assets/img_public/about/qywh/link_6.png'), href: 'https://i-membrane.com/', class: 'link_img_6'},
					{imgUrl: require('@/assets/img_public/about/qywh/link_4.png'), href: 'https://en.cupet.com', class: 'link_img_5'},
				],}
			],
		}
	},
	created(){
		let that = this;
		if(!navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)) {
			that.$router.replace({path: '/culture'});
		}
	},
	mounted() {
		let that = this;
		that.isLoading = false;
	},
	watch: {
		//
	},
	methods: {
		bfVideo() {
			let that = this;
			//that.$refs.example_video.pause();
		},
	},
}
</script>

<style lang="less" scoped>
	
/*开屏*/
.start_box{
	position: relative;
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	.btn_box{
		width: 100%;
		display: flex;
		align-items: center;
		padding: 40px 30px 0 30px;
	}
	.img_box{
		img{
			width: 100%;
		}
	}
	.tit_box{
		display: flex;
		align-items: center;
		padding-top: 20px;
		writing-mode: vertical-lr;
		width: 100%;
		line-height: unset;
		letter-spacing: 4px;
		font-size: 16px;
		color: #000000;
	}
}

/*轮播图*/
.banner_box{
	background-color: #541554;
	display: flex;
	position: relative;
	top: -1px;
	align-items: center;
	padding-top: 20px;
	.left{
		flex: 1;
		padding-left: 16px;
		.tit{
			font-size: 24px;
			font-weight: bold;
			color: #ffffff;
		}
		.txt{
			color: #ffffff;
			font-size: 12px;
		}
	}
	.right{
		width: auto;
		img{
			width: 165px;
		}
	}
}

/*块7*/
.main_box_7{
	.block_1{  /*区域1*/
		position: relative;
		padding-top: 50px;
		text-align: center;
		height: 360px;
		position: relative;
		overflow: hidden;
		.tit{
			padding-bottom: 10px;
			font-size: 28px;
			color: #071A21;
			font-weight: bold;
		}
		.txt{
			font-size: 16px;
			color: #333333;
		}
		.img_box{
			width: 100%;
			padding-top: 30px;
			position: absolute;
			top: 120px;
			video{
				width: 100%;
				background-color: transparent;
			}
			img{
				width: 100%;
				animation: rotation 360s linear 0s infinite;
			}
		}
		.bg{
			position: absolute;
			z-index: 1;
			bottom: -1px;
			img{
				width: 100%;
			}
		}
	}
}
@-webkit-keyframes rotation {
	0%{-webkit-transform:rotate(0deg);}
	50%{-webkit-transform:rotate(180deg);}
	100%{-webkit-transform:rotate(360deg);}
}
/*块6*/
.main_box_6{
	.block_3{  /*区域3*/
		padding: 60px 16px 0 0;
		.img_box{
			padding-bottom: 30px;
			img{width: 100%;}
		}
		.txt_box{
			padding-left: 16px;
			padding-bottom: 20px;
			text-align: center;
			.icon{
				position: relative;
				top: -6px;
				padding-right: 10px;
				font-size: 36px;
				font-weight: bold;
				color: #333333;
			}
			.tit{
				padding-right: 15px;
				margin-right: 12px;
				display: inline-block;
				line-height: 1;
				font-size: 18px;
				font-weight: bold;
				color: #071A21;
				border-right: 2px solid #071A21;
				padding-top: 4px;
			}
			.txt{
				position: relative;
				// top: -4px;
				font-size: 18px;
				color: #071A21;
				font-weight: bold;
			}
		}
	}
	.block_2{  /*区域2*/
		padding: 60px 16px 0 16px;
		.tit{
			padding: 0px 0 15px 0;
			margin-bottom: 10px;
			font-size: 28px;
			font-weight: bold;
			color: #071A21;
			line-height: 1;
			text-align: center;
		}
		.txt{
			font-size: 16px;
			line-height: 24px;
			color: #333333;
			text-align: center;
		}
	}
	.block_1{  /*区域1*/
		padding: 60px 0 0 16px;
		.img_box{
			padding-bottom: 30px;
			img{width: 100%;}
		}
		.txt_box{
			padding: 0 16px 0 0;
			.tit{font-size: 28px;font-weight: bold;color: #071A21;}
			.tit_spec{font-size: 16px;font-weight: bold;color: #071A21;padding: 10px 0 8px 0;}
			.txt{font-size: 16px;color: #333333;line-height: 24px;text-indent: 24px;}
		}
	}
}
/*块5*/
.main_box_5{
	padding: 60px 0;
	background-color: #F4EDE4;
	.block_1{  /*区域1*/
		text-align: center;
		.tit{
			padding-bottom: 15px;
			color: #071A21;
			font-size: 28px;
			font-weight: bold;
		}
		.txt{
			font-size: 16px;
			color: #333333;
			line-height: 24px;
		}
		.tips_box{
			padding-top: 30px;
			.tips_el{
				color: #999999;
				font-size: 12px;
				line-height: 18px;
			}
		}
	}
}
/*块4*/
.main_box_4{
	padding-bottom: 30px;
	.block_3{  /*区域3*/
		padding: 40px 16px 0 0;
		text-align: center;
		.img_box{
			padding-bottom: 30px;
			img{width: 100%;}
		}
		.txt_box{
			padding-bottom: 20px;
			.tit{font-size: 28px;font-weight: bold;color: #071A21;padding-bottom: 10px;}
			.txt{
				font-size: 16px;
				color: #333333;
				line-height: 24px;
			}
		}
	}
	.block_2{  /*区域2*/
		padding: 45px 16px 0px 16px;
		.main_box{
			.main_box_el{
				padding: 40px 0;
				margin-bottom: 20px;
				// border: 1px solid #541554;
				border-radius: 12px;
				text-align: center;
				background-color: #F7F6F9;
				.diver{
					width: 30px;
					height: 4px;
					background-color: #A50073;
					border-radius: 4px;
					margin: 8px auto 12px auto;
				}
				.tit{
					padding-bottom: 5px;
					font-size: 24px;
					color: #000000;
				}
				.txt{
					font-size: 16px;
					color: #071A21;
				}
			}
		}
	}
	.block_1{  /*区域1*/
		padding: 60px 0 0 16px;
		text-align: center;
		.img_box{
			padding-bottom: 30px;
			img{width: 100%;}
		}
		.tit{font-size: 28px;font-weight: bold;color: #071A21;padding-bottom: 10px;}
		.txt{
			font-size: 16px;
			color: #333333;
			line-height: 32px;
			padding: 4px 0;
			span{
				display: inline-block;
				width: 26px;
				height: 26px;
				line-height: 30px;
				display: inline-block;
				background-color: #F7F6F9;
				text-align: center;
				margin-right: 6px;
				border-radius: 50%;
				img{
					width: 15px;
					position: relative;
					top: 5px;
				}
			}
		}
	}
}
/*块3*/
.main_box_3{
	padding: 50px 0 0 0;
	background-color: #F5EDE5;
	.block_1{
		.main_box{
			display: flex;
			justify-content: center;
			.main_box_el{
				flex: 1;
				color: #000000;
				text-align: center;
				padding-bottom: 40px;
				.diver{
					width: 15px;
					height: 2px;
					border-radius: 4px;
					background-color: #A50073;
					margin: 0 auto;
					margin-bottom: 20px;
				}
				.tit{
					display: inline-block;
					padding-bottom: 10px;
					font-size: 28px;
					// border-bottom: 1px solid #ffffff;
				}
				.txt{
					font-size: 16px;
					line-height: 24px;
					color: #000000;
				}
			}
		}
	}
}
/*块2*/
.main_box_2{
	padding-bottom: 50px;
	.block_3{  /*区域3*/
		padding: 60px 16px 0 0;
		text-align: center;
		.img_box{
			padding-bottom: 30px;
			img{width: 100%;}
		}
		.tit{font-size: 28px;font-weight: bold;color: #071A21;padding-bottom: 10px;}
		.txt{font-size: 16px;color: #333333;}
	}
	.block_2{  /*区域2*/
		padding: 60px 0 0 16px;
		text-align: center;
		.img_box{
			padding-bottom: 30px;
			img{width: 100%;}
		}
		.tit{font-size: 28px;font-weight: bold;color: #071A21;padding-bottom: 10px;}
		.tit_spec{font-size: 16px;font-weight: bold;color: #071A21;padding-bottom: 10px;}
		.txt{font-size: 16px;color: #333333;line-height: 24px;}
	}
	.block_1{  /*区域1*/
		padding-top: 60px;
		.tit{
			padding-bottom: 30px;
			font-size: 28px;
			color: #071A21;
			font-weight: bold;
			text-align: center;
		}
		.main_box{
			display: flex;
			justify-content: center;
			.main_box_el{
				flex: 1;
				text-align: center;
				.title{
					padding-bottom: 10px;
					font-size: 16px;
					font-weight: bold;
					color: #071A21;
				}
				.txt{
					font-size: 12px;
					color: #333333;
					line-height: 18px;
				}
			}
		}
	}
}
/*块1*/
.main_box_1{
	padding-bottom: 50px;
	background-color: #FBF6EF;
	.block_2{  /*区域2*/
		padding: 60px 16px 0 0;
		text-align: center;
		.img_box{
			padding-bottom: 30px;
			img{width: 100%;}
		}
		.tit{font-size: 28px;font-weight: bold;color: #071A21;padding-bottom: 10px;}
		.txt{font-size: 16px;color: #333333;line-height: 24px;}
	}
	.block_1{  /*区域1*/
		padding: 60px 0 0 16px;
		text-align: center;
		.img_box{
			padding-bottom: 30px;
			img{width: 100%;}
		}
		.tit{font-size: 28px;font-weight: bold;color: #071A21;padding-bottom: 10px;}
		.txt{font-size: 16px;color: #333333;}
	}
	.link_box{  /*关联网站*/
		padding: 15px 16px 0 16px;
		.tit{
			color: #071A21;
			font-size: 20px;
			text-align: center;
		}
		.link_main{
			display: flex;
			padding-top: 15px;
			div{
				flex: 1;
			}
			.link_img_1{
				position: relative;
				left: -2%;
				img{width: 78px;}
			}
			.link_img_2{
				img{width: 120px;}
			}
			.link_img_3{
				position: relative;
				top:-10px;
				img{width: 85px;}
			}
			.link_img_4{
				position: relative;
				left: 0%;
				img{width: 75px;}
			}
			.link_img_5{
				position: relative;
				left: -2%;
				top: 4px;
				img{width: 68px;}
			}
			.link_img_6{
				position: relative;
				top: 4px;
				img{width: 90px;}
			}
			.link_img_7{
				img{width: 65px;}
			}
		}
	}
}


@media only screen and (min-device-width : 768px) and (max-device-width : 850px){
	.main_box_7{
		.block_1{  /*区域1*/
			height: 600px;
		}
	}
}

@media only screen and (min-device-width : 851px) and (max-device-width : 1024px){
	.main_box_7{
		.block_1{  /*区域1*/
			height: 750px;
		}
	}
}
</style>
